import { lazy } from 'react';

export const LazyCredentialsTypePickerWrapper = lazy(() =>
  import(
    /* webpackChunkName: "credentials-type-picker-wrapper" */ './CredentialsTypePickerWrapper'
  ).then((module) => ({
    default: module.CredentialsTypePickerWrapper,
  }))
);
